
    import Vue from 'vue';
    import DatePickerMenu from "./DatePickerMenu.vue";
    import {eventBus} from "@/services/event-bus";

    export default Vue.extend({
        props: ['dialog', 'value'],
        data() {
            return {}
        },
        computed: {
            period: {
                get(): any {
                    return this.value;
                },
                set(val: any) {
                    this.$emit('input', val);
                }
            },
        },
        components: {
            datePickerMenu: DatePickerMenu,
        },
        methods: {
            hideMenu() {
                this.$emit('hide-form');
            },
            editPeriod() {
                this.$emit('save-period', this.period);
            },
            isMonday(val: string): boolean {
                const date = new Date(val);
                return date.getDay() === 1 && date >= new Date();
            }
        },
        errorCaptured(err: Error, vm: Vue, info: string): boolean | void {
            eventBus.$emit('error', err.message);
        },
        watch: {
            'period.dateFrom'(newVal: any) {
                this.period.dateTo = new Date(new Date(newVal).getTime() + (1000 * 60 * 60 * 24 * 4)).toISOString().substr(0, 10)
            }
        }
    });
